import { gql } from '__generated__'

/**
 * Re-owns the guest session's demo rounds for the signed-in user, once
 * (`alreadyClaimed` on a repeat). One result per demo mode (FE-310).
 */
export const MERGE_GUEST_SESSION = gql(`
  mutation mergeGuestSession {
    mergeGuestSession {
      alreadyClaimed
      roundsMigrated
      wins
      upDown {
        roundsMigrated
        wins
        scoreMigrated
        rankDaily
        rankWeekly
        rankAlltime
      }
      upDownAi {
        roundsMigrated
        wins
        scoreMigrated
        rankDaily
        rankWeekly
        rankAlltime
      }
      bullseye {
        roundsMigrated
        wins
        scoreMigrated
        settledRounds
        exactHits
        avgErrorPct
        rankDaily
        rankWeekly
        rankAlltime
      }
    }
  }
`)
